import { findAllPlatforms_findAllPlatforms_items } from '__generatedTypes__/findAllPlatforms'

type PlatformType = Omit<findAllPlatforms_findAllPlatforms_items, '__typename'>

export function formatPlatformsWithKeys<Platform extends PlatformType>(platformsData: Platform[]) {
  return platformsData.map((platform) => ({
    ...platform,
    key: platform.slug,
  }))
}
